import { getCountryNameByCountryCode } from '@intelligence/utils/commonUtils';

interface IGetMobileCountriesChartNameParams {
  regionsCountries: any[];
  countryCode?: string;
  regionSegVal?: string;
  fallbackName?: string;
  localizedOthersName?: string;
}

export const getMobileCountriesChartName = (params: IGetMobileCountriesChartNameParams) => {
  const {
    regionsCountries,
    countryCode,
    regionSegVal = 'market',
    fallbackName = '',
    localizedOthersName = 'Others',
  } = params || {};
  const code = typeof countryCode === 'string' ? countryCode.trim() : '';
  const fallbackText = fallbackName || code;
  const lowerCode = code.toLowerCase();

  if (lowerCode === 'others') {
    return localizedOthersName || fallbackText;
  }

  const candidateCodes = Array.from(new Set([code, lowerCode, code.toUpperCase()].filter(Boolean)));

  for (const candidateCode of candidateCodes) {
    const countryName = getCountryNameByCountryCode(regionsCountries, candidateCode, regionSegVal);
    if (countryName && countryName !== candidateCode) {
      return countryName;
    }
  }

  return fallbackText;
};
